// OSM parcels (Overpass) for Emilia-Romagna, Italy
// bbox (cluster): south=44.779227, west=11.59453, north=44.788057, east=11.619122
// Data © OpenStreetMap contributors (ODbL): https://www.openstreetmap.org/copyright

export const PUGLIA_OSM_SECTIONS = [
  {
    "id": "OSM_W1449505018",
    "name": "OSM_W1449505018",
    "areaHa": 0.97,
    "center": [
      44.78088,
      11.609937
    ],
    "polygon": [
      [
        44.781227,
        11.60931
      ],
      [
        44.781522,
        11.610061
      ],
      [
        44.780352,
        11.610876
      ],
      [
        44.780071,
        11.610128
      ],
      [
        44.781227,
        11.60931
      ]
    ]
  },
  {
    "id": "OSM_W1449505034",
    "name": "OSM_W1449505034",
    "areaHa": 0.69,
    "center": [
      44.780451,
      11.609585
    ],
    "polygon": [
      [
        44.780071,
        11.610128
      ],
      [
        44.779888,
        11.609647
      ],
      [
        44.780997,
        11.608714
      ],
      [
        44.781227,
        11.60931
      ],
      [
        44.780071,
        11.610128
      ]
    ]
  },
  {
    "id": "OSM_W1449505017",
    "name": "OSM_W1449505017",
    "areaHa": 0.59,
    "center": [
      44.781181,
      11.610708
    ],
    "polygon": [
      [
        44.781712,
        11.610556
      ],
      [
        44.780559,
        11.611392
      ],
      [
        44.78038,
        11.610922
      ],
      [
        44.781544,
        11.610115
      ],
      [
        44.781712,
        11.610556
      ]
    ]
  },
  {
    "id": "OSM_W1449505030",
    "name": "OSM_W1449505030",
    "areaHa": 0.64,
    "center": [
      44.781506,
      11.609017
    ],
    "polygon": [
      [
        44.781399,
        11.609556
      ],
      [
        44.781054,
        11.608666
      ],
      [
        44.781657,
        11.608179
      ],
      [
        44.782019,
        11.60913
      ],
      [
        44.781399,
        11.609556
      ]
    ]
  },
  {
    "id": "OSM_W1449505057",
    "name": "OSM_W1449505057",
    "areaHa": 1,
    "center": [
      44.779807,
      11.610423
    ],
    "polygon": [
      [
        44.779832,
        11.609649
      ],
      [
        44.779227,
        11.610142
      ],
      [
        44.77977,
        11.611582
      ],
      [
        44.780372,
        11.611092
      ],
      [
        44.779832,
        11.609649
      ]
    ]
  },
  {
    "id": "OSM_W1449505033",
    "name": "OSM_W1449505033",
    "areaHa": 1.69,
    "center": [
      44.781452,
      11.611403
    ],
    "polygon": [
      [
        44.781712,
        11.610556
      ],
      [
        44.782244,
        11.611845
      ],
      [
        44.781036,
        11.612666
      ],
      [
        44.780559,
        11.611392
      ],
      [
        44.781712,
        11.610556
      ]
    ]
  },
  {
    "id": "OSM_W1449505023",
    "name": "OSM_W1449505023",
    "areaHa": 1.51,
    "center": [
      44.782292,
      11.610646
    ],
    "polygon": [
      [
        44.782874,
        11.61137
      ],
      [
        44.782291,
        11.611805
      ],
      [
        44.781399,
        11.609556
      ],
      [
        44.782019,
        11.60913
      ],
      [
        44.782874,
        11.61137
      ]
    ]
  },
  {
    "id": "OSM_W1449505032",
    "name": "OSM_W1449505032",
    "areaHa": 0.82,
    "center": [
      44.782342,
      11.608787
    ],
    "polygon": [
      [
        44.78189,
        11.608618
      ],
      [
        44.782257,
        11.609579
      ],
      [
        44.783064,
        11.609007
      ],
      [
        44.782609,
        11.608111
      ],
      [
        44.78189,
        11.608618
      ]
    ]
  },
  {
    "id": "OSM_W1449505016",
    "name": "OSM_W1449505016",
    "areaHa": 1.19,
    "center": [
      44.781725,
      11.612874
    ],
    "polygon": [
      [
        44.781384,
        11.613569
      ],
      [
        44.781036,
        11.612666
      ],
      [
        44.782244,
        11.611845
      ],
      [
        44.78258,
        11.612724
      ],
      [
        44.781384,
        11.613569
      ]
    ]
  },
  {
    "id": "OSM_W1449505084",
    "name": "OSM_W1449505084",
    "areaHa": 0.58,
    "center": [
      44.780837,
      11.613238
    ],
    "polygon": [
      [
        44.780871,
        11.612426
      ],
      [
        44.780313,
        11.612874
      ],
      [
        44.780754,
        11.613924
      ],
      [
        44.780829,
        11.613968
      ],
      [
        44.781046,
        11.613823
      ],
      [
        44.780885,
        11.613358
      ],
      [
        44.78113,
        11.613103
      ],
      [
        44.780871,
        11.612426
      ]
    ]
  },
  {
    "id": "OSM_W1449505020",
    "name": "OSM_W1449505020",
    "areaHa": 0.68,
    "center": [
      44.78024,
      11.613532
    ],
    "polygon": [
      [
        44.780249,
        11.612921
      ],
      [
        44.779736,
        11.613336
      ],
      [
        44.78022,
        11.614441
      ],
      [
        44.780747,
        11.614041
      ],
      [
        44.780249,
        11.612921
      ]
    ]
  },
  {
    "id": "OSM_W1449505029",
    "name": "OSM_W1449505029",
    "areaHa": 0.5,
    "center": [
      44.783789,
      11.611536
    ],
    "polygon": [
      [
        44.784109,
        11.611079
      ],
      [
        44.78432,
        11.611502
      ],
      [
        44.78329,
        11.612225
      ],
      [
        44.783118,
        11.611794
      ],
      [
        44.784109,
        11.611079
      ]
    ]
  },
  {
    "id": "OSM_W1449505040",
    "name": "OSM_W1449505040",
    "areaHa": 1.07,
    "center": [
      44.784331,
      11.608849
    ],
    "polygon": [
      [
        44.784913,
        11.60829
      ],
      [
        44.78319,
        11.609095
      ],
      [
        44.783549,
        11.609823
      ],
      [
        44.785091,
        11.608746
      ],
      [
        44.784913,
        11.60829
      ]
    ]
  },
  {
    "id": "OSM_W1449505039",
    "name": "OSM_W1449505039",
    "areaHa": 1.74,
    "center": [
      44.7839,
      11.60718
    ],
    "polygon": [
      [
        44.783215,
        11.606441
      ],
      [
        44.78412,
        11.608601
      ],
      [
        44.78489,
        11.608249
      ],
      [
        44.784059,
        11.606166
      ],
      [
        44.783215,
        11.606441
      ]
    ]
  },
  {
    "id": "OSM_W1449505015",
    "name": "OSM_W1449505015",
    "areaHa": 0.67,
    "center": [
      44.780642,
      11.615021
    ],
    "polygon": [
      [
        44.77994,
        11.615324
      ],
      [
        44.780123,
        11.615662
      ],
      [
        44.781681,
        11.614595
      ],
      [
        44.781528,
        11.614198
      ],
      [
        44.77994,
        11.615324
      ]
    ]
  },
  {
    "id": "OSM_W1449505053",
    "name": "OSM_W1449505053",
    "areaHa": 0.88,
    "center": [
      44.784589,
      11.60944
    ],
    "polygon": [
      [
        44.785105,
        11.608802
      ],
      [
        44.785302,
        11.609321
      ],
      [
        44.78384,
        11.610393
      ],
      [
        44.783593,
        11.609882
      ],
      [
        44.785105,
        11.608802
      ]
    ]
  },
  {
    "id": "OSM_W1449505062",
    "name": "OSM_W1449505062",
    "areaHa": 0.83,
    "center": [
      44.781224,
      11.61543
    ],
    "polygon": [
      [
        44.781908,
        11.615182
      ],
      [
        44.781712,
        11.614707
      ],
      [
        44.780172,
        11.615811
      ],
      [
        44.780421,
        11.616267
      ],
      [
        44.781908,
        11.615182
      ]
    ]
  },
  {
    "id": "OSM_W1449505052",
    "name": "OSM_W1449505052",
    "areaHa": 1.74,
    "center": [
      44.784845,
      11.61037
    ],
    "polygon": [
      [
        44.78384,
        11.610393
      ],
      [
        44.784381,
        11.611452
      ],
      [
        44.785518,
        11.610642
      ],
      [
        44.785401,
        11.610266
      ],
      [
        44.785632,
        11.610126
      ],
      [
        44.785302,
        11.609321
      ],
      [
        44.78384,
        11.610393
      ]
    ]
  },
  {
    "id": "OSM_W1449505046",
    "name": "OSM_W1449505046",
    "areaHa": 0.63,
    "center": [
      44.783449,
      11.605182
    ],
    "polygon": [
      [
        44.783259,
        11.60566
      ],
      [
        44.78304,
        11.604708
      ],
      [
        44.783735,
        11.604454
      ],
      [
        44.783955,
        11.605427
      ],
      [
        44.783259,
        11.60566
      ]
    ]
  },
  {
    "id": "OSM_W1449505041",
    "name": "OSM_W1449505041",
    "areaHa": 1.82,
    "center": [
      44.785014,
      11.606781
    ],
    "polygon": [
      [
        44.785073,
        11.605872
      ],
      [
        44.784126,
        11.606142
      ],
      [
        44.784965,
        11.608202
      ],
      [
        44.78583,
        11.607817
      ],
      [
        44.785073,
        11.605872
      ]
    ]
  },
  {
    "id": "OSM_W1449505043",
    "name": "OSM_W1449505043",
    "areaHa": 1.39,
    "center": [
      44.784484,
      11.60489
    ],
    "polygon": [
      [
        44.784729,
        11.60409
      ],
      [
        44.783789,
        11.604436
      ],
      [
        44.784155,
        11.606038
      ],
      [
        44.785017,
        11.605796
      ],
      [
        44.784729,
        11.60409
      ]
    ]
  },
  {
    "id": "OSM_W1449505068",
    "name": "OSM_W1449505068",
    "areaHa": 0.71,
    "center": [
      44.78233,
      11.61769
    ],
    "polygon": [
      [
        44.782797,
        11.617782
      ],
      [
        44.781849,
        11.618301
      ],
      [
        44.781598,
        11.617387
      ],
      [
        44.782611,
        11.617199
      ],
      [
        44.782797,
        11.617782
      ]
    ]
  },
  {
    "id": "OSM_W1449505047",
    "name": "OSM_W1449505047",
    "areaHa": 1.02,
    "center": [
      44.783868,
      11.602922
    ],
    "polygon": [
      [
        44.783103,
        11.602954
      ],
      [
        44.78322,
        11.603536
      ],
      [
        44.78502,
        11.602896
      ],
      [
        44.784895,
        11.602269
      ],
      [
        44.783103,
        11.602954
      ]
    ]
  },
  {
    "id": "OSM_W1449505050",
    "name": "OSM_W1449505050",
    "areaHa": 1.64,
    "center": [
      44.784818,
      11.603828
    ],
    "polygon": [
      [
        44.785732,
        11.603717
      ],
      [
        44.785519,
        11.602862
      ],
      [
        44.783581,
        11.603521
      ],
      [
        44.783789,
        11.604436
      ],
      [
        44.784729,
        11.60409
      ],
      [
        44.784717,
        11.604024
      ],
      [
        44.784774,
        11.603999
      ],
      [
        44.784791,
        11.604081
      ],
      [
        44.785732,
        11.603717
      ]
    ]
  },
  {
    "id": "OSM_W1449505045",
    "name": "OSM_W1449505045",
    "areaHa": 0.63,
    "center": [
      44.785383,
      11.604409
    ],
    "polygon": [
      [
        44.785532,
        11.604307
      ],
      [
        44.785548,
        11.604541
      ],
      [
        44.785236,
        11.604634
      ],
      [
        44.785279,
        11.604897
      ],
      [
        44.784948,
        11.604985
      ],
      [
        44.784791,
        11.604081
      ],
      [
        44.785732,
        11.603717
      ],
      [
        44.785845,
        11.604213
      ],
      [
        44.785532,
        11.604307
      ]
    ]
  },
  {
    "id": "OSM_W1449505069",
    "name": "OSM_W1449505069",
    "areaHa": 0.82,
    "center": [
      44.782332,
      11.618412
    ],
    "polygon": [
      [
        44.781849,
        11.618301
      ],
      [
        44.782069,
        11.619122
      ],
      [
        44.783099,
        11.618554
      ],
      [
        44.782797,
        11.617782
      ],
      [
        44.781849,
        11.618301
      ]
    ]
  },
  {
    "id": "OSM_W202699596",
    "name": "OSM_W202699596",
    "areaHa": 0.99,
    "center": [
      44.78633,
      11.601015
    ],
    "polygon": [
      [
        44.786301,
        11.600307
      ],
      [
        44.785696,
        11.600967
      ],
      [
        44.786358,
        11.602065
      ],
      [
        44.786994,
        11.601428
      ],
      [
        44.786301,
        11.600307
      ]
    ]
  },
  {
    "id": "OSM_W202699624",
    "name": "OSM_W202699624",
    "areaHa": 0.61,
    "center": [
      44.786806,
      11.600524
    ],
    "polygon": [
      [
        44.786678,
        11.59991
      ],
      [
        44.786301,
        11.600307
      ],
      [
        44.786994,
        11.601428
      ],
      [
        44.787379,
        11.601064
      ],
      [
        44.786678,
        11.59991
      ]
    ]
  },
  {
    "id": "OSM_W202699634",
    "name": "OSM_W202699634",
    "areaHa": 1.1,
    "center": [
      44.787353,
      11.599966
    ],
    "polygon": [
      [
        44.787326,
        11.599234
      ],
      [
        44.786678,
        11.59991
      ],
      [
        44.787379,
        11.601064
      ],
      [
        44.788057,
        11.600388
      ],
      [
        44.787326,
        11.599234
      ]
    ]
  },
  {
    "id": "OSM_W202699625",
    "name": "OSM_W202699625",
    "areaHa": 1.57,
    "center": [
      44.784254,
      11.595536
    ],
    "polygon": [
      [
        44.785003,
        11.59453
      ],
      [
        44.782957,
        11.595696
      ],
      [
        44.783232,
        11.596241
      ],
      [
        44.783365,
        11.596595
      ],
      [
        44.784443,
        11.595951
      ],
      [
        44.784367,
        11.595731
      ],
      [
        44.784577,
        11.595608
      ],
      [
        44.784504,
        11.595404
      ],
      [
        44.785083,
        11.595071
      ],
      [
        44.785003,
        11.59453
      ]
    ]
  }
];
